import { render } from "./BannerSection.vue?vue&type=template&id=4f647cf9&scoped=true"
const script = {}

import "./BannerSection.vue?vue&type=style&index=0&id=4f647cf9&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f647cf9"]])

export default __exports__